import { useContext } from "react";

import ParamsContext from "context/params/paramsContext";
import { useApi } from "shared/hooks/useApi";
import { ENDPOINTS, FILTER_NAMES, TABLE_NAMES } from "shared/types/enums";

const useGetSingleTaskGroupEndpoint = () => {
    const { queryParams, setReloadItems } = useContext(ParamsContext);

    const { getData, handleResponse } = useApi();

    const rootCompanyId = queryParams?.[FILTER_NAMES.RootCompany];
    const companyIds = queryParams?.[FILTER_NAMES.CompanyId];

    const rootQuery = `?${FILTER_NAMES.RootCompany}=${rootCompanyId}`;

    const companyIdQuery = companyIds
        ? `&${FILTER_NAMES.CompanyId}=${companyIds}`
        : "";

    const getSingleTaskGroupEndpoint = (id: number) =>
        `${ENDPOINTS.Batches}/${id}${rootQuery}${companyIdQuery}`;

    const getSingleTaskGroupData = async (
        id: number,
        successCallback?: (data: any) => void
    ) => {
        try {
            const endpoint = getSingleTaskGroupEndpoint(id);
            const { data } = await getData(endpoint);

            successCallback?.(data);
            setReloadItems(TABLE_NAMES.Tasks);
        } catch (error) {
            handleResponse(error);
        }
    };

    return { getSingleTaskGroupEndpoint, getSingleTaskGroupData };
};

export { useGetSingleTaskGroupEndpoint };
